module.exports = __webpack_public_path__ + "static/media/item_picked.24d4c1e2.svg";